<template>
	<div>

    	<v-list nopadding two-line v-if="data.primaryMobileNumber || data.email || (data.addresses && data.addresses.length)">

	        <!-- <div>
	        	<v-list-tile>
	        		<v-list-tile-action>
	        			<v-icon>account_box</v-icon>
	        		</v-list-tile-action>
	          		<v-list-tile-content>
	          			<v-list-tile-sub-title>Ledger Type</v-list-tile-sub-title>
	          			<v-list-tile-title>
	          				{{data.groupTypeId == 101 ? 'Customer' : data.groupTypeId == 102 ? 'Supplier' : 'Other'}}
	          			</v-list-tile-title>
	            	</v-list-tile-content>
	        	</v-list-tile>
	        	<v-divider></v-divider>
	        </div> -->

	       <div v-if="data.groupTypeId != 103">
	       		<div v-if="data.groupTypeId == 101 && $root.TransactionSettings.beatRouteArea">
		        	<v-list-tile>
		        		<v-list-tile-action>
		        			<v-icon>map</v-icon>
		        		</v-list-tile-action>
			          	<v-list-tile-content>
			          		<v-list-tile-sub-title>Beat/Area/Route</v-list-tile-sub-title>
			          		<v-list-tile-title>{{data.routeName ? data.routeName : '-'}}</v-list-tile-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		        </div>
	       		<div v-if="data.primaryMobileNumber">
		        	<v-list-tile>
		        		<v-list-tile-action>
		        			<!-- <v-icon>phone</v-icon> -->
		        			<a :href="'tel:'+data.primaryMobileNumber" style="text-decoration:none"><v-icon>call</v-icon></a>
		        		</v-list-tile-action>
			          	<v-list-tile-content>
			          		<!-- <v-list-tile-sub-title>Mobile Number</v-list-tile-sub-title> -->
			          		<a :href="'tel:'+data.primaryMobileNumber" style="text-decoration:none">
			          			<v-list-tile-title dark-opacity-color>
				          			{{data.primaryMobileNumber ? data.primaryMobileNumber : ''}}
				          			<!-- {{data.primaryMobileNumber}}{{data.primaryMobileNumber && data.mobile ? ',' : ''}}
				              		{{data.mobile ? data.mobile : ''}}
				              		{{!data.primaryMobileNumber && !data.mobile ? '-' : ''}} -->
				          		</v-list-tile-title>	
			          		</a>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		        </div>
		       	<div v-if="data.email">
		       	 	<v-list-tile>
		       	 		<v-list-tile-action>
		       	 			<a :href="'mailto:'+data.email" style="text-decoration:none"><v-icon>email</v-icon></a>
		        		</v-list-tile-action>
			          	<v-list-tile-content>
			          		<!-- <v-list-tile-sub-title>Email</v-list-tile-sub-title> -->
			          		<a :href="'mailto:'+data.email ? data.email : ''" style="text-decoration:none">
			          			<v-list-tile-title dark-opacity-color>{{data.email ? data.email : ''}}</v-list-tile-title>
			          		</a>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		       	</div>								
		       	<!-- <div>
		       	 	<v-list-tile>
		       	 		<v-list-tile-action>
		        			<v-icon>phone</v-icon>
		        		</v-list-tile-action>
			          	<v-list-tile-content>
			          		<v-list-tile-title>Telephone</v-list-tile-title>
			              	<v-list-tile-sub-title>{{data.phone ? data.phone : '-'}}</v-list-tile-sub-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		       	</div> -->

		       	<div v-if="data.addresses && data.addresses.length">
		       		<v-list-tile class="auto-tile-height" v-for="(address, index) in data.addresses" :key="index" two-line>
		       			<v-list-tile-action>
		        			<v-icon>location_city</v-icon>
		        		</v-list-tile-action>
			          	<v-list-tile-content>
			          		<v-list-tile-sub-title>
								{{address.groupTypeId == 101 ? 'Billing Address' : address.groupTypeId == 102 ? 'Shipping Address' : 'Billing and Shipping Address' }}
								<span v-if="address.isDefault && address.groupTypeId == 102">(Default)</span>
							</v-list-tile-sub-title>
			          		<v-list-tile-title>{{fn_mergeAddress(address)}}</v-list-tile-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider></v-divider>
		       	</div>
	       </div>
	       
	    </v-list>

		<v-list>
			<div v-if="data.msmeUdyamNumber">
				<v-divider></v-divider>
					<v-list-tile>
						<v-list-tile-content>
							<v-list-tile-sub-title>MSME/Udyam No</v-list-tile-sub-title>
							<v-list-tile-title>{{data.msmeUdyamNumber}}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</div>
		</v-list>

	    <v-list nopadding margin-top-ten two-line v-if="data.gstType && data.groupTypeId != 103">
	        <v-subheader light>GST Details</v-subheader>
	        <v-divider></v-divider>
	        <div>
	        	<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>GST Type</v-list-tile-sub-title>
		          		<v-list-tile-title>{{fn_getGstTypeName(data.gstType)}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider></v-divider>
	        </div>
	        <div v-if="data.gstNumber">
	       		<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>GST Number(GSTIN)</v-list-tile-sub-title>
		          		<v-list-tile-title>{{data.gstNumber}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider></v-divider>
	       	</div>
	       	<div v-if="data.placeOfSupply">
	       		<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>State/Place of Supply</v-list-tile-sub-title>
		          		<v-list-tile-title>{{data.placeOfSupply}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider></v-divider>
	       	</div>
	       	<div v-if="data.panNumber">
	       		<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>PAN No.</v-list-tile-sub-title>
		          		<v-list-tile-title>{{data.panNumber}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider></v-divider>
	       	</div>
			<div v-if="data.aadharNumber">
	       		<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>Aadhar Number</v-list-tile-sub-title>
		          		<v-list-tile-title>{{data.aadharNumber}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider></v-divider>
	       	</div>
	       	<div v-if="data.country">
	       		<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>Country</v-list-tile-sub-title>
		          		<v-list-tile-title>{{data.country}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider></v-divider>
	       	</div>
	       	<div v-if="data.currency">
	       		<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>Currency</v-list-tile-sub-title>
		          		<v-list-tile-title>{{data.currency}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider></v-divider>
	       	</div>
	       	
	    </v-list>

	    <v-list nopadding margin-top-ten two-line>
	        <v-subheader light>Accounting</v-subheader>
	        <v-divider></v-divider>
	        <div>
	        	<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>Accounting Group</v-list-tile-sub-title>
		          		<v-list-tile-title>{{data.accountGroupName}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider></v-divider>
	        </div>

	    </v-list>

		<v-list nopadding margin-top-ten two-line v-if="data.accountFields && data.accountFields.length">
	        <v-subheader light>Custom Fields</v-subheader>
	        <v-divider></v-divider>
	        <div v-for="(item, index) in data.accountFields" :key="index" v-if="item.fieldValue">
	        	<v-list-tile>
		          	<v-list-tile-content>
		          		<v-list-tile-sub-title>{{ item.fieldName }}</v-list-tile-sub-title>
		          		<v-list-tile-title>{{item.fieldValue}}</v-list-tile-title>
		            </v-list-tile-content>
		        </v-list-tile>
		        <v-divider v-if="data.accountFields.length - 1 != index"></v-divider>
	        </div>

	    </v-list>
 		
 	</div>
</template>

<script>
	export default{
		props:['data'],
		methods:{
			fn_getGstTypeName: function (gstType) {
				if(gstType == 101)
					return 'Registered Business - Regular';
				else if(gstType == 102)
					return 'Registered Business - Composition';
				else if(gstType == 103)
					return 'Unregistered Business';
				else if(gstType == 104)
					return 'Consumer';
				else if(gstType == 105)
					return 'Overseas';
				else if(gstType == 106)
					return 'Special Economic Zone';
				else if(gstType == 107)
					return 'Deemed Export';
			},

			fn_mergeAddress: function(address){
				let billerShipperName, addressLine, city, state, pincode, country;

				address.billerShipperName ? billerShipperName = address.billerShipperName + ', ' : billerShipperName = '';
				address.addressLine ? addressLine = address.addressLine + ', ' : addressLine = '';
				address.city ? city = address.city + ', ' : city = '';
				address.state ? state = address.state + ', ' : state = '';
				address.pincode ? pincode = address.pincode + ' - ' : pincode = '';
				address.country ? country = address.country : country = '';

				return billerShipperName + addressLine + city + state + pincode + country;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/display_tabs/details.vue